.feedback-form {
    width: 600px;
    background-color: var(--white);
    padding: 40px;
    border-radius: 16px;
}
